module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Weather/Snow2-a6245f0308844885c59b915f547b8b73.svg";